import { request } from '@umijs/max';

export async function login(params) {
  return request('/v1/auth/login/', {
    method: 'POST',
    data: params,
  });
}

export async function outLogin(params) {
  return request('/v1/auth/logout/', {
    method: 'POST',
    data: params,
  });
}

// 获取个人信息
export async function queryCurrentUser() {
  return request('/v1/auth/userInfo/', {
    method: 'GET',
  });
}

// 获取验证码
export async function senCode(params) {
  return request('/v1/auth/sendCode/', {
    method: 'POST',
    data: params,
  });
}

// 修改密码
export async function resetPassword(params) {
  return request('/v1/auth/reset/password/', {
    method: 'POST',
    data: params,
  });
}

// 修改密码
export async function resetPwdByCode(params) {
  return request('/v1/auth/reset/pwdByCode/', {
    method: 'POST',
    data: params,
  });
}

// 获取公司列表
export async function getCompanyList() {
  return request('/v1/company/', {
    method: 'GET',
  });
}

// 新建公司
export async function addCompany(params) {
  return request('/v1/company/', {
    method: 'POST',
    data: params,
  });
}

// 编辑公司
export async function editCompany(params) {
  return request('/v1/company/' + params.app_id + '/', {
    method: 'PUT',
    data: params,
  });
}

// 删除公司
export async function delCompany(params) {
  return request('/v1/company/' + params.app_id + '/', {
    method: 'DELETE',
    data: params,
  });
}

// 导出组织架构，可传 app_id 限定当前公司及下级公司范围
export async function exportOrganizationTree(params: {
  scope: 'all' | 'current';
  app_id?: string;
}) {
  return request('/v1/organization/export/', {
    method: 'POST',
    data: params,
  });
}

// 获取部门列表
export async function getDepList(params) {
  return request('/v1/department/', {
    method: 'GET',
    params: params
  });
}

// 新建部门
export async function addDep(params) {
  return request('/v1/department/', {
    method: 'POST',
    data: params,
  });
}

// 编辑部门
export async function editDep(params) {
  return request('/v1/department/' + params.dep_id + '/', {
    method: 'PUT',
    data: params,
  });
}

// 部门详情
export async function detailDep(params) {
  return request('/v1/department/' + params.dep_id + '/', {
    method: 'GET',
    params: params,
  });
}

// 删除部门
export async function delDep(params) {
  return request('/v1/department/' + params.dep_id + '/', {
    method: 'DELETE',
    data: params,
  });
}

// 获取成员列表
export async function getMemberList(params) {
  return request('/v1/member/', {
    method: 'GET',
    params: params
  });
}

// 新建成员
export async function addMember(params) {
  return request('/v1/member/', {
    method: 'POST',
    data: params,
  });
}

// 编辑成员
export async function editMember(params) {
  return request('/v1/member/' + params._id + '/', {
    method: 'PUT',
    data: params,
  });
}

// 获取角色列表
export async function getRoleList(params) {
  return request('/v1/role/', {
    method: 'GET',
    params: params
  });
}

// 新建角色
export async function addRole(params) {
  return request('/v1/role/', {
    method: 'POST',
    data: params,
  });
}

// 编辑角色
export async function editRole(params) {
  return request('/v1/role/' + params.role_id + '/', {
    method: 'PUT',
    data: params,
  });
}

// 删除角色
export async function delRole(params) {
  return request('/v1/role/' + params.role_id + '/', {
    method: 'DELETE',
    data: params,
  });
}

// 获取角色成员列表
export async function getRoleMemberList(params) {
  return request('/v1/roleMember/', {
    method: 'GET',
    params: params
  });
}

// 新建角色成员
export async function addRoleMember(params) {
  return request('/v1/roleMember/', {
    method: 'POST',
    data: params,
  });
}

// 删除角色成员
export async function delRoleMember(params) {
  return request('/v1/roleMember/' + params._id + '/', {
    method: 'DELETE',
    data: params,
  });
}

// 获取模版列表
export async function getTemList(params) {
  return request('/v1/template/', {
    method: 'GET',
    params: params
  });
}

// 获取当前管理员可维护的PPT模板公司范围
export async function getTemplateCompanyOptions() {
  return request('/v1/template/companies/', {
    method: 'GET',
  });
}

// 新建模版
export async function addTem(params) {
  return request('/v1/template/', {
    method: 'POST',
    data: params,
  });
}

// 编辑模版
export async function editTem(params) {
  return request('/v1/template/' + params.tem_id + '/', {
    method: 'PUT',
    data: params,
  });
}

// 删除模版
export async function delTem(params) {
  return request('/v1/template/' + params.tem_id + '/', {
    method: 'DELETE',
    data: params,
  });
}

// 获取用语集列表
export async function getLangList(params) {
  return request('/v1/lang/', {
    method: 'GET',
    params: params
  });
}

// 新建用语集
export async function addLang(params) {
  return request('/v1/lang/', {
    method: 'POST',
    data: params,
  });
}

// 编辑用语集
export async function editLang(params) {
  return request('/v1/lang/' + params.lang_id + '/', {
    method: 'PUT',
    data: params,
  });
}

// 删除用语集
export async function delLang(params) {
  return request('/v1/lang/' + params.lang_id + '/', {
    method: 'DELETE',
    data: params,
  });
}

// 导出用语集
export async function exportLang(params) {
  return request('/v1/lang/file/export/', {
    method: 'POST',
    data: params,
  });
}

// ===== 术语干预管理 =====
// 获取术语列表
export async function getTermList(params) {
  return request('/v1/term/', {
    method: 'GET',
    params: params
  });
}

// 新建术语
export async function addTerm(params) {
  return request('/v1/term/', {
    method: 'POST',
    data: params,
  });
}

// 编辑术语
export async function editTerm(params) {
  return request('/v1/term/' + params.term_id + '/', {
    method: 'PUT',
    data: params,
  });
}

// 删除术语
export async function delTerm(params) {
  return request('/v1/term/' + params.term_id + '/', {
    method: 'DELETE',
    data: params,
  });
}

// 导出术语
export async function exportTerm(params) {
  return request('/v1/term/file/export/', {
    method: 'POST',
    data: params,
  });
}

// 获取安全设置
export async function getSecurity(params) {
  return request('/v1/security/info/', {
    method: 'GET',
    params: params
  });
}

// 安全设置
export async function editSecurity(params) {
  return request('/v1/security/edit/', {
    method: 'POST',
    data: params,
  });
}

// 导入成员 - 预览
export async function previewMemberImport(
  file: File,
  appId?: string,
  scope: 'all' | 'current' = 'current',
) {
  const formData = new FormData();
  formData.append('file', file);
  if (appId) formData.append('app_id', appId);
  formData.append('scope', scope);
  return request('/v1/member/import/preview/', {
    method: 'POST',
    data: formData,
  });
}

// 导入成员 - 执行
export async function executeMemberImport(
  file: File,
  appId?: string,
  scope: 'all' | 'current' = 'current',
) {
  const formData = new FormData();
  formData.append('file', file);
  if (appId) formData.append('app_id', appId);
  formData.append('scope', scope);
  formData.append('generate_compare', '1');
  return request('/v1/member/import/execute/', {
    method: 'POST',
    data: formData,
    timeout: 120000,
  });
}


// 删除热词
export async function delHot(params) {
  return request('/v1/hotwords/' + params._id + '/', {
    method: 'DELETE',
    data: params,
  });
}

// 更新热词
export async function addHot(params) {
  return request('/v1/hotwords/', {
    method: 'POST',
    data: params,
  });
}

// 热词列表
export async function listHot(params) {
  return request('/v1/hotwords/', {
    method: 'GET',
    params: params
  });
}

// 密钥
export async function apiConf(params) {
  return request('/v1/conf/', {
    method: 'GET',
    params: params
  });
}

export async function getMeetingTopicLimit(params) {
  return request('/v1/meeting-topic-limit/', {
    method: 'GET',
    params,
  });
}

export async function editMeetingTopicLimit(params) {
  return request('/v1/meeting-topic-limit/', {
    method: 'POST',
    data: params,
  });
}

// 版本配置
export async function getVersionConfigs(params: any) {
  return request('/v1/version-config/', {
    method: 'GET',
    params: params,
  });
}

export async function updateVersionConfig(moduleKey: string, params: any) {
  return request('/v1/version-config/' + moduleKey + '/', {
    method: 'PUT',
    data: params,
  });
}

export async function publishVersionConfig(moduleKey: string, params: any) {
  return request('/v1/version-config/' + moduleKey + '/publish/', {
    method: 'POST',
    data: params,
  });
}

export async function updateVersionHistory(historyId: string, params: any) {
  return request('/v1/version-config/history/' + historyId + '/', {
    method: 'PUT',
    data: params,
  });
}

export async function deleteVersionHistory(historyId: string) {
  return request('/v1/version-config/history/' + historyId + '/', {
    method: 'DELETE',
  });
}

// 会议报表
export async function getMeetingFeedbackReport(params: any) {
  return request('/api/meeting/feedback/', {
    method: 'GET',
    params: params
  });
}




// 会议反馈素材
export async function getMeetingFeedbackMaterials(params: any) {
  return request('/api/meeting/feedback/material/', {
    method: 'GET',
    params: params,
  });
}

export async function addMeetingFeedbackMaterial(params: any) {
  return request('/api/meeting/feedback/material/', {
    method: 'POST',
    data: params,
  });
}

export async function updateMeetingFeedbackMaterial(materialId: string, params: any) {
  return request(`/api/meeting/feedback/material/${materialId}/`, {
    method: 'PUT',
    data: params,
  });
}

export async function deleteMeetingFeedbackMaterial(materialId: string) {
  return request(`/api/meeting/feedback/material/${materialId}/`, {
    method: 'DELETE',
  });
}
